module.exports = __webpack_public_path__ + "img/icon_location_epa.285adb92.svg";